import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import PagesCommonHeader from "../../../common_components/PagesCommonHeader";
import TableToolbar from "../../../common_components/TableToolbar";
const IntegrationCredentialsHeader = () => (_jsx(PagesCommonHeader, { height: "58px", title: "Integration Credentials", rightSection: _jsx(Box, { display: "flex", alignItems: "center", gap: 1, children: _jsx(TableToolbar, { title: "", showSearch: false, showFullScreen: true }) }) }));
export default IntegrationCredentialsHeader;
